<template>
  <div id="sections">
    <section id="start" class="uk-margin-large-top uk-margin-medium-bottom">
      <div class="uk-container uk-container-large">
        <router-link to="/" class="uk-button-text uk-text-bold"><span class="uk-margin-small-right" data-uk-icon="chevron-left"></span>zur&uuml;ck</router-link>
      </div>
      <div class="uk-container uk-container-large uk-flex uk-flex-center">
        <div  class="uk-button-group"
              data-uk-switcher="animation: uk-animation-fade; connect: #switcher;"
        >
          <button class="uk-button uk-button-default" type="button">Patenverzeichnis</button>
          <button class="uk-button uk-button-default" type="button">Orgel-&Uuml;bersicht</button>
        </div>
      </div>
    </section>
    <ul id="switcher" class="uk-switcher uk-margin">
      <li>
        <section id="patenverzeichnis">
          <div class="uk-container uk-container-large uk-margin-large-top uk-margin-large-bottom">
            <h1>Patenverzeichnis</h1>
            <table class="uk-table uk-table-divider uk-table-small uk-table-hover">
              <thead>
                <tr>
                  <th>Pate</th><th>Register</th><th>Pfeifen</th>
                </tr>
              </thead>
              <tbody v-for="s in sponsorshipList" v-bind:key="s.id" v-html="s.body_text"></tbody>
            </table>
          </div>
        </section>
      </li>
      <li>
        <section id="orgel">
          <div class="uk-container uk-container-large uk-margin-large-top uk-margin-large-bottom">
            <div class="uk-inline">
              <h1>Chororgel</h1>
              <table class="uk-table">
                <template v-for="work in organ_work.list">
                  <organ-work-table-header :work="work" :tone="tone" v-bind:key="work.id"/>
                  <!-- eslint-disable-next-line-->
                  <tbody v-for="s in organ_stop.list" v-if="work.id === s.parentID" v-bind:key="s.id">
                  <tr class="organ-stop">
                    <th class="first-column">{{ s.title }}</th>
                    <td class="second-column">{{ s.length }}'</td>
                    <td>
                      <pipes-register-svg :s="s"/>
                    </td>
                  </tr>
                  </tbody>
                </template>
              </table>
              <div id="loading" class="uk-overlay uk-overlay-default uk-position-cover" v-if="loading">
                <div class="uk-position-center">
                  <div class="uk-position-center uk-width-medium uk-text-center">
                    <div data-uk-spinner></div>
                    <p v-if="$apollo.queries.organ_work.loading">Lade Orgel-Werke...</p>
                    <p v-if="$apollo.queries.organ_stop.loading">Lade Register...</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </li>
    </ul>
  </div>
</template>

<script>
import {
  ORGAN_QUERY,
  STOPS_QUERY,
  TONE_QUERY,
  WORKS_QUERY,
  SPONSORSHIP_LIST
} from '../constants/graphql'
import OrganWorkTableHeader from './OrganWorkTableHeader'
import PipesRegisterSvg from './PipesRegisterSvg'
import _ from 'lodash'

const XRegExp = require('xregexp')

export default {
  name: 'Organ',
  components: {PipesRegisterSvg, OrganWorkTableHeader},
  data () {
    return {
      pipe_organ: {},
      organ_work: {},
      organ_stop: {},
      sponsorshipList: {},
      tone: {},
      loading: 0
    }
  },
  methods: {
    getClassList (amount) {
      return 'price-' + amount.toString()
    },
    pipeRectTranslation (pipeIndex, toneIndex) {
      let x = 0
      let translate = ''
      if (pipeIndex !== toneIndex) {
        x = (toneIndex) * 25
      } else {
        x = (pipeIndex + 1) * 25 - 25
      }
      translate = 'translate(' + x + ' 0)'
      return translate
    }
  },
  apollo: {
    pipe_organ: {
      query: ORGAN_QUERY
    },
    organ_work: {
      query: WORKS_QUERY
    },
    organ_stop: {
      query: STOPS_QUERY
    },
    tone: {
      query: TONE_QUERY
    },
    sponsorshipList: {
      query: SPONSORSHIP_LIST,
      update (data) {
        let entries = data.repeater_sponsor_list_repeater.list
        let newEntries = []

        let rowIndex = 0
        _.forEach(entries, (entry) => {
          // markiere alle Tabellenzeilen
          let splitRegExp = new XRegExp('(</tr>)', 'g')
          let bodyTextToSplit = XRegExp.replace(entry.body_text, splitRegExp, '$1#')
          // speichere Zeilen in ein Array
          let tableRows = _.split(bodyTextToSplit, '#')
          // entferne das leere letzte Element
          if (_.last(tableRows) === '') {
            tableRows = _.dropRight(tableRows)
          }

          // durchlaufe alle Zeilen
          _.forEach(tableRows, (tableRow) => {
            // suche den Namen aus dem HTML Markup und
            // speichere ihn ein eigenes property
            let rowRegExp = new XRegExp('<span class="uk-text-bold">(?<name>.*)</span>', 'g')
            newEntries.push({
              id: entry.id + '_' + rowIndex,
              body_text: tableRow,
              name: XRegExp.exec(tableRow, rowRegExp).name
            })
            rowIndex += 1
          })
          rowIndex += 1
        })
        // Sortieren der Einträge nach Namen
        return _.orderBy(newEntries, ['name'], ['asc'])
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/scss/variables";
@import "~uikit/src/scss/variables-theme";

[data-uk-icon*="chevron"] {
  svg {
    polyline {
      stroke-width: 3px;
    }
  }
}

#app {
  .uk-inline {
    margin-left: auto;
    margin-right: auto;
    min-width: 100%;
    min-height: 100vh;
  }
}

table {
  table-layout: auto;
  &.uk-table {
    th {
      text-transform: none;
      font-weight: bolder;
      font-size: $base-body-font-size;
    }
  }
  .first-column {
    padding-left: 0;
    white-space: nowrap;
  }
  .second-column {
    white-space: nowrap;
  }
  .organ-stop {
    th {
      font-weight: $base-body-font-weight;
    }
    th, td {
      vertical-align: top;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.price-1500 {
  fill: $color-amount-1500;
}
.price-1000 {
  fill: $color-amount-1000;
}
.price-500 {
  fill: $color-amount-500;
}
.price-250 {
  fill: $color-amount-250;
}
.price-100 {
  fill: $color-amount-100;
}
.price-50 {
  fill: $color-amount-50;
}

</style>



// WEBPACK FOOTER //
// src/components/Organ.vue